import { create } from "zustand";
import GetOfflineModeByCode from "../api-layer/offline-mode-api/GetOfflineModeByCode";
import PatchOfflineMode from "../api-layer/offline-mode-api/PatchOfflineMode";
import GetSiteSettings from "../api-layer/site-settings-api/GetSiteSettings";

export const useSiteSettingsStore = create((set, get) => ({
  siteSettings: null,
  loading: false,
  error: null,

  fetchSiteSettings: async () => {
    set({ loading: true, error: null });

    try {
      const response = await GetSiteSettings();
      set({
        siteSettings: response.data,
        loading: false,
      });
    } catch (err) {
      set({
        error: "Failed to fetch offline mode",
        loading: false,
      });
    }
  },

}));